var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagesHeaderButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0003 0.916689C9.22101 0.915891 7.47326 1.38612 5.9346 2.27959C4.39595 3.17306 3.12124 4.45792 2.24001 6.00361C1.35878 7.54931 0.902431 9.30074 0.917346 11.0799C0.932262 12.8591 1.41791 14.6027 2.32493 16.1334L0.972846 19.8532C0.922466 19.9916 0.906189 20.1401 0.925394 20.2862C0.944598 20.4322 0.998718 20.5715 1.08317 20.6922C1.16762 20.8129 1.27992 20.9115 1.41055 20.9796C1.54117 21.0476 1.68629 21.0833 1.8336 21.0834C1.94047 21.0831 2.04651 21.0645 2.1471 21.0284L5.86693 19.6754C7.20194 20.4662 8.70147 20.9383 10.2488 21.0549C11.7961 21.1714 13.3494 20.9293 14.7878 20.3474C16.2262 19.7654 17.511 18.8594 18.542 17.6997C19.5729 16.5401 20.3224 15.1581 20.732 13.6615C21.1415 12.1648 21.2001 10.5938 20.9033 9.07082C20.6064 7.5478 19.962 6.11384 19.0203 4.88058C18.0786 3.64732 16.865 2.64803 15.474 1.96051C14.0829 1.27298 12.5519 0.915774 11.0003 0.916689Z",
    fill: "#9498B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagesHeaderButton);
export default __webpack_public_path__ + "static/media/imagesHeaderButton.5d3159e5f09d995b7c55778567055068.svg";
export { ForwardRef as ReactComponent };